export const CPUABI = [
  {
    "type": "constructor",
    "inputs": [
      {
        "name": "engine",
        "type": "address",
        "internalType": "contract IEngine"
      },
      {
        "name": "matchmakers",
        "type": "address[]",
        "internalType": "address[]"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "executeGame",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "moves",
        "type": "bytes",
        "internalType": "bytes"
      }
    ],
    "outputs": [
      {
        "name": "winner",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "executeSlotGame",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "moves",
        "type": "bytes",
        "internalType": "bytes"
      }
    ],
    "outputs": [
      {
        "name": "winner",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "selectMoveWithCpuMove",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "playerMoveIndex",
        "type": "uint8",
        "internalType": "uint8"
      },
      {
        "name": "playerSalt",
        "type": "uint104",
        "internalType": "uint104"
      },
      {
        "name": "playerExtraData",
        "type": "uint16",
        "internalType": "uint16"
      },
      {
        "name": "cpuMoveIndex",
        "type": "uint8",
        "internalType": "uint8"
      },
      {
        "name": "cpuExtraData",
        "type": "uint16",
        "internalType": "uint16"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "selectSlotMovesWithCpuMoves",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "playerSidePacked",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "cpuMove0",
        "type": "uint8",
        "internalType": "uint8"
      },
      {
        "name": "cpuExtra0",
        "type": "uint16",
        "internalType": "uint16"
      },
      {
        "name": "cpuMove1",
        "type": "uint8",
        "internalType": "uint8"
      },
      {
        "name": "cpuExtra1",
        "type": "uint16",
        "internalType": "uint16"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "startBattle",
    "inputs": [
      {
        "name": "proposal",
        "type": "tuple",
        "internalType": "struct ProposedBattle",
        "components": [
          {
            "name": "p0",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "p0TeamIndex",
            "type": "uint96",
            "internalType": "uint96"
          },
          {
            "name": "p0TeamHash",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "p1",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "p1TeamIndex",
            "type": "uint96",
            "internalType": "uint96"
          },
          {
            "name": "teamRegistry",
            "type": "address",
            "internalType": "contract ITeamRegistry"
          },
          {
            "name": "rngOracle",
            "type": "address",
            "internalType": "contract IRandomnessOracle"
          },
          {
            "name": "ruleset",
            "type": "address",
            "internalType": "contract IRuleset"
          },
          {
            "name": "moveManager",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "matchmaker",
            "type": "address",
            "internalType": "contract IMatchmaker"
          },
          {
            "name": "engineHooks",
            "type": "address[]",
            "internalType": "contract IEngineHook[]"
          }
        ]
      }
    ],
    "outputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "startCustomBattle",
    "inputs": [
      {
        "name": "p",
        "type": "tuple",
        "internalType": "struct CustomBattleProposal",
        "components": [
          {
            "name": "p0",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "p0TeamIndex",
            "type": "uint96",
            "internalType": "uint96"
          },
          {
            "name": "monIndices",
            "type": "uint256[]",
            "internalType": "uint256[]"
          },
          {
            "name": "facetIds",
            "type": "uint8[]",
            "internalType": "uint8[]"
          },
          {
            "name": "moveSelections",
            "type": "uint8[]",
            "internalType": "uint8[]"
          },
          {
            "name": "teamRegistry",
            "type": "address",
            "internalType": "contract ITeamRegistry"
          },
          {
            "name": "rngOracle",
            "type": "address",
            "internalType": "contract IRandomnessOracle"
          },
          {
            "name": "ruleset",
            "type": "address",
            "internalType": "contract IRuleset"
          },
          {
            "name": "moveManager",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "matchmaker",
            "type": "address",
            "internalType": "contract IMatchmaker"
          },
          {
            "name": "engineHooks",
            "type": "address[]",
            "internalType": "contract IEngineHook[]"
          },
          {
            "name": "battleMode",
            "type": "uint8",
            "internalType": "uint8"
          }
        ]
      }
    ],
    "outputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "startCustomMultiBattle",
    "inputs": [
      {
        "name": "p",
        "type": "tuple",
        "internalType": "struct CustomMultiBattleProposal",
        "components": [
          {
            "name": "p0",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "p0TeamIndex",
            "type": "uint96",
            "internalType": "uint96"
          },
          {
            "name": "p1",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "p1TeamIndex",
            "type": "uint96",
            "internalType": "uint96"
          },
          {
            "name": "p2",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "p2TeamIndex",
            "type": "uint96",
            "internalType": "uint96"
          },
          {
            "name": "p3",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "p3TeamIndex",
            "type": "uint96",
            "internalType": "uint96"
          },
          {
            "name": "seatConfigs",
            "type": "tuple[3]",
            "internalType": "struct SeatPhantomConfig[3]",
            "components": [
              {
                "name": "monIndices",
                "type": "uint256[]",
                "internalType": "uint256[]"
              },
              {
                "name": "facetIds",
                "type": "uint8[]",
                "internalType": "uint8[]"
              },
              {
                "name": "moveSelections",
                "type": "uint8[]",
                "internalType": "uint8[]"
              }
            ]
          },
          {
            "name": "teamRegistry",
            "type": "address",
            "internalType": "contract ITeamRegistry"
          },
          {
            "name": "rngOracle",
            "type": "address",
            "internalType": "contract IRandomnessOracle"
          },
          {
            "name": "ruleset",
            "type": "address",
            "internalType": "contract IRuleset"
          },
          {
            "name": "moveManager",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "matchmaker",
            "type": "address",
            "internalType": "contract IMatchmaker"
          },
          {
            "name": "engineHooks",
            "type": "address[]",
            "internalType": "contract IEngineHook[]"
          }
        ]
      }
    ],
    "outputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "error",
    "name": "NotP0",
    "inputs": []
  },
  {
    "type": "error",
    "name": "SeatNotCpu",
    "inputs": []
  }
] as const;
